/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */
import logoOnly from '../assets/Pacesetterlogo_icon.png';
import logoText from '../assets/pacesetter.png';
import logoComplete from '../assets/Pacesetterlogo_icon.png';

export const PUBLIC_URL = `${process.env.PUBLIC_URL}`;
export const API_URL = `${process.env.REACT_APP_REST_API_HOST}`;
export const SENTRY_DSN = `${process.env.REACT_APP_SENTRY_DSN}`;
export const PAGE_SIZE = 10;
export const DATE_FORMAT = 'MM/DD/YYYY HH:mm:ss';
export const SEARCH_DATE_FORMAT = 'MM-DD-YYYY';
export const DISPATCH_DATE_FORMAT = 'MM/DD/YYYY';
export const ORDINAL_DATE_FORMAT = 'Do MMM, YYYY';
export const TIME_12H_FORMAT = 'h:mm A';
export const ERROR_MESSAGE = { message: 'Server Error. Please Try again' };

export const PACESETTER_APPLICATION_TYPES = {
  ADMIN: 'ADMIN',
  CLIENT: 'CLIENT',
  SYSTEM: 'SYSTEM',
  client: 'client',
  admin: 'admin',
};

export const PAYMENT_TITLE = {
  CARD: 'Card',
  CASH: 'Cash',
  ECHECK: 'E-Check',
  CHECK: 'Check',
};

export const BUSINESS = 'business';
export const INDIVIDUAL = 'individual';
export const PAYMENT_MODE_TYPE = {
  NEXIO_CARD: 'NEXIO_CARD',
  STRIPE_CARD: 'STRIPE_CARD',
  AUTHORIZE_CARD: 'AUTHORIZE_CARD',
  AUTHORIZE_ECHECK: 'AUTHORIZE_ECHECK',
  NEXIO_ECHECK: 'NEXIO_ECHECK',
  CHECK: 'CHECK',
  CASH: 'CASH',
};
export const NEXIO_PAYMENT_API = {
  ECHECK: 'pay/v3/processECheck',
  CARD: 'pay/v3',
};

export const NEXIO_PAYMENT_EVENT = {
  CARD_PAYMENT_PROCESS: 'processed',
  ECHECK_PAYMENT_PROCESS: 'eCheckProcessed',
};
export const LOGO = {
  logoOnly: logoOnly,
  logoText: logoText,
  logoComplete: logoComplete,
};

export const DOCUMENT_UPLOAD_ERROR = {
  FILING_STATUS_MISSING: ['CLE10015', 'FILING_STATUS_MISSING'],
  SPOUSE_MISSING: ['SPOUSE_MISSING'],
};

export const FILING_STATUS = {
  SINGLE: 'Single',
  MARRIED_FILING_JOINT: 'Married filing joint',
  MARRIED_FILING_SEPARATE: 'Married filing separate',
  HEAD_OF_HOUSEHOLD: 'Head of household',
};

export const MONTH_NAME = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const WEEK_NAME = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const TIME_DROPDOWN = [
  '12:00 AM',
  '1:00 AM',
  '2:00 AM',
  '3:00 AM',
  '4:00 AM',
  '5:00 AM',
  '6:00 AM',
  '7:00 AM',
  '8:00 AM',
  '9:00 AM',
  '10:00 AM',
  '11:00 AM',
  '12:00 PM',
  '1:00 PM',
  '2:00 PM',
  '3:00 PM',
  '4:00 PM',
  '5:00 PM',
  '6:00 PM',
  '7:00 PM',
  '8:00 PM',
  '9:00 PM',
  '10:00 PM',
  '11:00 PM',
];

export const WEEK_OPTION = [
  'SUNDAY',
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
];

export const priority = [
  {
    id: 1,
    code: 'HIGH',
    title: 'HIGH',
  },
  {
    id: 2,
    code: 'MEDIUM',
    title: 'MEDIUM',
  },
  {
    id: 3,
    code: 'LOW',
    title: 'LOW',
  },
];

// client constants
export const CLIENT_JWT_TOKEN = 'pacesetter-client-token';
export const CLIENT_PERMISSION_KEY = 'pacesetter-client-permission';
export const CLIENT_USER_FULL_NAME = 'pacesetter-client-fullName';
export const CLIENT_ENFORCE_UPDATE = 'pacesetter-client-enforceUpdate';
export const CLIENT_USER_ID = 'pacesetter-client-id';
export const CLIENT_USER_TYPE = 'pacesetter-client-userType';
export const CLIENT_CLIENT_TYPE = 'pacesetter-client-clientType';
export const CLIENT_USER_EMAIL = 'pacesetter-client-userEmail';
export const CLIENT_SELECTED_ASSOCIATION_ID = 'pacesetter-client-selectedAssociationId';
export const CLIENT_SELECTED_ASSOCIATION_TYPE = 'pacesetter-client-selectedAssociationType';
export const CLIENT_PREFERRED_NAME = 'pacesetter-client-preferredName';
export const CLIENT_ACCESS_CODE = 'pacesetter-client-access-code';
export const CLIENT_TEMP_PASSWORD = 'pacesetter-client-temp-password';
export const CLIENT_TEMP_EMAIL = 'pacesetter-client-temp-email';
export const CLIENT_IS_PRIMARY_ACCOUNT = 'pacesetter-client-is-primary';
export const CLIENT_PROFILE = 'pacesetter-client-profile';
export const CLIENT_ENFORCE_PASSWORD = 'pacesetter-client-enforce-password';
export const CLIENT_IS_SPOUSE = 'pacesetter-client-is-spouse';
export const CLIENT_ENCRYPTION_KEY = 'pacesetter-client-encryption-key';
export const CLIENT_USER_SPOUSE_ID = 'pacesetter-client-spouse-id';
export const CLIENT_COMPANY_DATA = 'pacesetter-client-company';
export const CLIENT_USER_PATHS = 'pacesetter-client-user-paths';
export const CLIENT_COUNTRY_CODE = 'pacesetter-client-country-code';
export const CLIENT_OTP_VERIFICATION_CODE = 'pacesetter-client-otp-verification-code';
export const CLIENT_SELECTED_LANGUAGE = 'pacesetter-client-selected-language';
export const CLIENT_TAX_REPRESENTATIVE_ID = 'pacesetter-client-tax-representative-id';
export const CLIENT_TAX_REPRESENTATIVE_EMAIL = 'pacesetter-client-tax-representative-email';
export const CLIENT_TAX_REPRESENTATIVE_NAME = 'pacesetter-client-tax-representative-name';
export const CLIENT_SWITCHED_ID = 'pacesetter-client-switched-user-id';
export const CLIENT_LOGIN_MODE = 'pacesetter-client-login-mode';
export const CLIENT_OTP_VERIFICATION_FORM = 'pacesetter-client-otp-verification-form';
export const CLIENT_OTP_EMAIL = 'pacesetter-client-otp-email';
// admin constants
export const ADMIN_JWT_TOKEN = 'pacesetter-admin-token';
export const ADMIN_PERMISSION_KEY = 'pacesetter-admin-permission';
export const ADMIN_USER_FULL_NAME = 'pacesetter-admin-fullName';
export const ADMIN_USER_ID = 'pacesetter-admin-id';
export const ADMIN_USER_TYPE = 'pacesetter-admin-userType';
export const ADMIN_PREFERRED_NAME = 'pacesetter-admin-preferredName';
export const ADMIN_REF_URL = 'pacesetter-admin-refUrl';
export const ADMIN_ACCESS_CODE = 'pacesetter-admin-access-code';
export const ADMIN_TEMP_PASSWORD = 'pacesetter-admin-temp-password';
export const ADMIN_UNIQUE_ID = 'pacesetter-admin-unique-id';
export const ADMIN_SELECTED_MEMBER_ID = 'pacesetter-admin-memberId';
export const ADMIN_MAIN_PROFILE_FULL_NAME = 'pacesetter-admin-main-profile-fullName';
export const ADMIN_MAIN_PROFILE_USER_ID = 'pacesetter-admin-main-profile-userId';
export const ADMIN_SUPERVISOR_PROFILE_FULL_NAME = 'pacesetter-admin-supervisor-profile-fullName';
export const ADMIN_SUPERVISOR_PROFILE_USER_ID = 'pacesetter-admin-supervisor-profile-userId';
export const ADMIN_USER_PATHS = 'pacesetter-admin-user-paths';
export const ADMIN_PREV_PATH = 'pacesetter-admin-prev-path';
export const ADMIN_ENFORCE_PASSWORD = 'pacesetter-admin-enforce-password';
export const ADMIN_ENCRYPTION_KEY = 'pacesetter-admin-encryption-key';
export const ADMIN_COMPANY_DATA = 'pacesetter-admin-company';
export const ADMIN_COUNTRY_CODE = 'pacesetter-admin-country-code';
export const ADMIN_SELECTED_LANGUAGE = 'pacesetter-admin-selected-language';
export const ADMIN_USER_EMAIL = 'pacesetter-admin-user-email';
export const ADMIN_SUPPORT_DATA = 'pacesetter-admin-support';
export const ADMIN_SEARCH_URL = 'pacesetter-admin-search-url';
export const ADMIN_FAIL_REPORT_CONFIGURATION = 'pacesetter-admin-fail-report-configuration';

// system constants
export const SYSTEM_JWT_TOKEN = 'pacesetter-system-token';
export const SYSTEM_PERMISSION_KEY = 'pacesetter-system-permission';
export const SYSTEM_USER_FULL_NAME = 'pacesetter-system-fullName';
export const SYSTEM_USER_ID = 'pacesetter-system-id';
export const SYSTEM_USER_TYPE = 'pacesetter-system-userType';
export const SYSTEM_PREFERRED_NAME = 'pacesetter-system-preferredName';
export const SYSTEM_REF_URL = 'pacesetter-system-refUrl';
export const SYSTEM_ACCESS_CODE = 'pacesetter-system-access-code';
export const SYSTEM_ENCRYPTION_KEY = 'pacesetter-system-encryption-key';
export const SYSTEM_SUPPORT_COMPANY_DATA = 'pacesetter-system-support-company';
export const SYSTEM_SIGNUP_EMAIL = 'pacesetter-system-signup-email';

export const PDFJD_WORKER_CDN_URL =
  '//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.js';

export const FILE_UPLOAD_CONFIG = {
  acceptThresholdSize: 100 * 1024 * 1024,
  acceptWidth: 1500,
  acceptHeight: 1500,
  acceptFileTypes:
    '.heic, .heif, image/heic, image/heif, image/png, image/jpg, image/jpeg, application/pdf, text/plain, application/ppt,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document ,application/vnd.openxmlformats-officedocument.wordprocessingml.template, application/vnd.ms-word.document.macroEnabled.12,application/vnd.ms-word.template.macroEnabled.12,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.spreadsheetml.template,application/vnd.ms-excel.sheet.macroEnabled.12,application/vnd.ms-excel.template.macroEnabled.12,application/vnd.ms-excel.addin.macroEnabled.12,application/vnd.ms-excel.sheet.binary.macroEnabled.12,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.openxmlformats-officedocument.presentationml.template,application/vnd.openxmlformats-officedocument.presentationml.slideshow,application/vnd.ms-powerpoint.addin.macroEnabled.12,application/vnd.ms-powerpoint.presentation.macroEnabled.12,application/vnd.ms-powerpoint.template.macroEnabled.12,application/vnd.ms-powerpoint.slideshow.macroEnabled.12,application/csv,text/csv',
  acceptFileTypesForTaxAuth: 'image/png, image/jpg, image/jpeg, application/pdf',
};

export const NOTIFICATION_CONST = {
  DEFAULT: 'default',
  DENIED: 'denied',
  GRANTED: 'granted',
};

// Check token in 15 min
export const APPLICATION_TOKEN_CHECK_TIMER = 900000;
export const SESSION_CHECK_JWT_TOKEN_THRESHOLD = 20;
export const LAST_API_TIME = 'lastApiTime';
export const SESSION_CHECK_JWT_TOKEN_THRESHOLD_FOR_UPDATE = 50;

export const CLIENT_IMPORT_CSV_CHECKER_STRING = {
  INDIVIDUAL: 'SSN',
  INDIVIDUAL_WITH_ASTERISK: '(*)SSN',
  BUSINESS: 'EIN',
  BUSINESS_WITH_ASTERISK: '(*)EIN',
  CHECKER_START: 0,
  CHECKER_END: 6,
};

// Tax filing years
const currentYear = new Date().getFullYear() - 1;
const activeYearForTaxFiling = new Date().getFullYear();

export const TAX_FILING_YEARS = [
  {
    value: '',
    label: 'ALL',
  },
  ...Array.from({ length: 5 }, (_, index) => ({
    value: (activeYearForTaxFiling - index).toString(),
    label: (activeYearForTaxFiling - index).toString(),
  })),
];

export const DOCUMENT_ACTION_TYPE = {
  REUPLOAD: 'reUpload',
  MARK_COMPLETE: 'markComplete',
  SIGNATURE_UPLOAD: 'signatureUpload',
};

export const statusOptions = [
  {
    code: 'OPEN',
    title: 'OPEN',
  },
  {
    code: 'PARK',
    title: 'PARKED',
  },
  {
    code: 'COMPLETE',
    title: 'COMPLETED',
  },
  {
    code: 'ALL',
    title: 'ALL',
  },
];

export const priorityOptions = [
  {
    code: 'ALL',
    title: 'ALL',
  },
  {
    code: 'HIGH',
    title: 'HIGH',
  },
  {
    code: 'LOW',
    title: 'LOW',
  },
  {
    code: 'MEDIUM',
    title: 'MEDIUM',
  },
];

export const IDENTIFIER = {
  ALL: 'ALL',
  TAX: 'tax',
  TRUE: 'TRUE',
  YEAR: 'year',
  READ: 'READ',
  ADMIN: 'admin',
  NOTES: 'NOTES',
  UNREAD: 'UNREAD',
  WEEKLY: 'WEEKLY',
  CREATE: 'create',
  UNPAID: 'UNPAID',
  MONTHLY: 'MONTHLY',
  add_task: 'add_task',
  COMPLETE: 'complete',
  DOCUMENT: 'DOCUMENT',
  BUSINESS: 'BUSINESS',
  COMPLETE: 'complete',
  DOCUMENT: 'DOCUMENT',
  BI_WEEKLY: 'BI_WEEKLY',
  SIGNATURE: 'SIGNATURE',
  signature: 'signature',
  QUARTERLY: 'QUARTERLY',
  TAX_FILING: 'tax-filing',
  INDIVIDUAL: 'INDIVIDUAL',
  ADMIN_NOTES: 'ADMIN_NOTES',
  add_invoice: 'add_invoice',
  CLIENT_NOTES: 'CLIENT_NOTES',
  CLIENT_MESSAGE: 'client-message',
  YEAR_WISE_FOLDER: 'YEAR_WISE_FOLDER',
  task_template_new: 'task_template_new',
  TAX_AUTHORIZATION: 'TAX_AUTHORIZATION',
  tax_authorization: 'tax-authorization',
  task_template_detail: 'task_template_detail',
  TAX_AUTHORIZATION_SIGNATURE: 'tax-authorization-signature',
};

export const SIGNATURE_SIDEBAR_ITEMS = [
  { name: 'Signature Details', key: 'SIGNATURE' },
  { name: 'Notes', key: 'NOTES' },
];

export const CURRENT_YEAR_ARRAY = [
  {
    code: String(currentYear),
    title: String(currentYear),
  },
];

export const PACESETTER_YOUTUBE_CHANNEL_LINK =
  'https://www.youtube.com/@pacesettertax4829/playlists';

export const ZENDESK_SUPPORT_ID = `${process.env.REACT_APP_ZENDESK_SUPPORT_ID}`;

export const RECURRING_EVENT_FREQUENCY_COUNT = {
  QUARTERLY: 4,
  MONTHLY: 1,
  BI_WEEKLY: 2,
  WEEKLY: 1,
};

export const NOTES_TYPE = [
  {
    value: IDENTIFIER.ADMIN_NOTES,
    label: 'lbl_admin_notes',
  },
  {
    value: IDENTIFIER.CLIENT_NOTES,
    label: 'lbl_client_notes',
  },
];

export const REPORT_PDF_CONSTANTS = {
  UNIT: 'pt',
  SIZE: 'A4',
  ORIENTATION: 'portrait',
  MARGIN_LEFT: 40,
  START_Y: 240,
  DEFAULT_START_Y: 220,
  START_Y_TASKS: 270,
  START_Y_TASKS_DATE_RANGE: 255,
  START_Y_DATE_RANGE: 260,
  START_Y_TABLE_DATE_RANGE_TASKS: 265,
};

export const paymentTypesToCheck = ['Nexio', 'Stripe', 'Authorize'];

export const UPLOAD_TYPE = {
  DOC_UPLOAD: 'DOC_UPLOAD',
  FOLDER_DOC_UPLOAD: 'FOLDER_DOC_UPLOAD',
};

export const PAYMENT_GATEWAYS = {
  STRIPE: 'STRIPE',
  AUTHORIZE: 'AUTHORIZE',
  NEXIO: 'NEXIO',
};

export const INTEGRATION_TYPES = {
  QUICKBOOK: 'QUICKBOOK',
};

export const FILE_LOCATION_TYPE = {
  DOCUMENTS: 'DOCUMENTS',
  FOLDER: 'FOLDER',
};

export const TASK_STATUS = {
  MARK_UNREAD: 'MARK UNREAD',
};

export const DATE_RANGE_FILTER_TYPE = {
  TODAY: 'today',
  FIFTEEN_DAYS: '15days',
  THIRTY_DAYS: '30days',
  WEEK: 'week',
  MONTH: 'month',
};

export const TABLE_SORT_TYPES = {
  ASC: 'ASC',
  DESC: 'DESC',
};

export const TABLE_SORT_FIELDS = {
  LAST_MODIFIED_ON: 'lastModifiedOn',
};

export const DYNAMIC_FIELD_DATASOURCE_TYPES = {
  ADMIN: 'ADMIN',
  CLIENT: 'CLIENT',
};

export const DYNAMIC_FIELD_TYPES = {
  TEXT_FIELD: 'TEXT_FIELD',
  TEXT_AREA: 'TEXT_AREA',
  DATE: 'DATE',
  NUMBER: 'NUMBER',
  DROPDOWN: 'DROPDOWN',
  DATA_SOURCE: 'DATA_SOURCE',
};

export const FIELD_TYPE_OPTIONS = [
  { value: 'TEXT_FIELD', label: 'Text Field' },
  { value: 'TEXT_AREA', label: 'Text Area' },
  { value: 'DATE', label: 'Date' },
  { value: 'NUMBER', label: 'Number' },
  { value: 'DROPDOWN', label: 'Dropdown' },
  { value: 'DATA_SOURCE', label: 'Data Source' },
];

export const TARGET_ENTITY_OPTIONS = [
  {
    value: 'INDIVIDUAL',
    label: 'Individual',
  },
  {
    value: 'BUSINESS',
    label: 'Business',
  },
];

export const DATA_SOURCE_DROPDOWN_OPTIONS = [
  {
    label: 'Admin',
    value: DYNAMIC_FIELD_DATASOURCE_TYPES.ADMIN,
  },
  {
    label: 'Client',
    value: DYNAMIC_FIELD_DATASOURCE_TYPES.CLIENT,
  },
];

export const CLIENT_TYPES = {
  INDIVIDUAL: 'INDIVIDUAL',
  BUSINESS: 'BUSINESS',
};

export const MENU_NAMES = {
  CHAT: 'Chat',
  MESSAGES: 'Messages',
  SUPPORT: 'Support',
  TICKETS: 'Tickets',
};

export const UNARY_OPERATORS = ['EMPTY', 'NOT_EMPTY'];

export const REPORT_BUILDER_STEPS = [
  { index: 0, label: 'Select Report', key: 'select-report' },
  { index: 1, label: 'Set Up Columns', key: 'set-up-columns' },
  { index: 2, label: 'Choose Criteria', key: 'choose-criteria' },
  { index: 3, label: 'Run Report', key: 'run-report' },
];

export const TOTAL_STEPS = REPORT_BUILDER_STEPS.length;

export const FILTER_TYPE_CONFIG = {
  STRING: {
    operators: ['EQUALS', 'NOT_EQUALS', 'CONTAINS', 'NOT_CONTAINS'],
    autoOperator: null,
  },
  SELECT: {
    operators: ['IN', 'NOT_IN'],
    autoOperator: null,
  },
  DATE_RANGE: {
    operators: ['BETWEEN'],
    autoOperator: 'BETWEEN',
  },
  BOOLEAN: {
    operators: ['EQUALS'],
    autoOperator: 'EQUALS',
  },
  BETWEEN: {
    operators: ['BETWEEN'],
    autoOperator: 'BETWEEN',
  },
};

export const EMAIL_STRICT_OPERATORS = ['EQUALS', 'NOT_EQUALS'];

export const ARRAY_OPERATORS = ['IN', 'NOT_IN', 'BETWEEN'];

export const getModuleMeta = (code) => MODULE_META[code] || { icon: '📄', displayName: code };

export const DEFAULT_PAGE_SIZE = 50;
export const PAGE_SIZE_OPTIONS = [25, 50, 100, 250];

export const TAX_REPRESENTATIVE_COLUMN_CODES = [
  'taxRepresentative',
  'taxRepresntativeName',
  'tax_representative',
  'taxRepresentativeId',
  'tax_representative_id',
  'reviewerId',
  'assignedById',
  'assignedToId',
];

export const TASK_TEMPLATE_COLUMN_CODES = [
  'taskTemplate',
  'task_template',
  'taskTemplateId',
  'taskTemplateName',
];

export const APPOINTMENT_LOCATION_COLUMN_CODES = ['locationId'];

export const ROLES_COLUMN_CODES = ['role'];

export const MONTH_COLUMN_CODES = ['month'];

export const STATE_COLUMN_CODES = ['state'];

export const APPOINTMENT_SERVICE_CODES = ['serviceId'];

export const CLIENT_COLUMN_CODES = [
  'owner_name',
  'clientId',
  'owner_id',
  'associate_id',
  'client_id',
];

export const SELECT_OVERRIDE_COLUMN_CODES = [
  ...TAX_REPRESENTATIVE_COLUMN_CODES,
  ...CLIENT_COLUMN_CODES,
  ...ROLES_COLUMN_CODES,
  ...TASK_TEMPLATE_COLUMN_CODES,
];

export const REPORT_FILTER_COLUMN_CODES = {
  SELECT: 'SELECT',
  DATE_RANGE: 'DATE_RANGE',
  STRING: 'STRING',
  BOOLEAN: 'BOOLEAN',
  BETWEEN: 'BETWEEN',
  NUMBER: 'NUMBER',
};

export const REPORT_FILTER_COLUMNS_CODE_TO_EXCLUDE = ['client_name', 'tax_representative'];

export const REPORT_COLUMN_TYPES = {
  MONTH: 'month',
  QUARTER: 'quarter',
  ASSOCIATE_ID: 'associate_id',
  YEAR: 'year',
  EMAIL: 'email',
};

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
export const MONTHS_FULL = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
export const QUARTERS = ['Q1', 'Q2', 'Q3', 'Q4'];
export const QUARTERS_FULL = ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'];
export const OTP_LENGTH = 6;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
